<template>
    <ion-grid class="swipable">
        <ion-row class="content-row" align-items-center>
            <ion-col size-xs="12" offset-xs="0" size-sm="8" offset-sm="2" size-md="6" offset-md="3" size-lg="4" offset-lg="4" text-center>
                <ion-card>
                    <ion-card-header>
                        <ion-card-title text-left color="primary">{{ $t('components.alert-dates.title') }}</ion-card-title>
                    </ion-card-header>
                    <ion-card-content class="dates">
                        <ion-card class="date-selector">
                            <ion-button expand="block" :fill="weekends ? 'solid' : 'outline'" size="default" @click="toggleWeekends" class="selectable" :color="weekends ? 'light' : 'medium'"><ion-icon mode="ios" :color="weekends ? 'primary' : 'medium'" :name="weekends ? 'checkmark-circle' : 'radio-button-off'"></ion-icon>{{ $t('components.alert-dates.weekends') }}</ion-button>
                            <ion-button v-for="date in customDates" :class="[{ 'custom-date-first': date.id == 0 }, 'selectable']" :key="date.id" expand="full" :fill="date.selected ? 'solid' : 'outline'" size="default" @click="toggleCustom(date.id)" :color="date.selected ? 'light' : 'medium'"><ion-icon mode="ios" :color="date.selected ? 'primary' : 'medium'" :name="date.selected ? 'checkmark-circle' : 'radio-button-off'"></ion-icon>{{date.text}}</ion-button>
                            <ion-button class="add-custom" @click="createModal" size="default" expand="block" fill="outline" color="primary"><ion-icon name="add-circle"></ion-icon>{{ $t('components.alert-dates.add-custom') }}</ion-button>
                        </ion-card>
                        <transition name="collapse-fade" mode="out-in">
                            <ion-button v-if="saveButton" color="primary" class="save" @click="clickSave"><ion-icon name="calendar"></ion-icon>{{ $t('components.alert-dates.save-dates') }}</ion-button>
                        </transition>
                        <div class="divider">{{ $t('components.alert-dates.or') }}</div>
                        <ion-card>
                            <ion-item lines="none" text-center button="true" class="anytime" @click="clickAnytime"><ion-list><ion-label>{{ $t('components.alert-dates.anytime') }}</ion-label><ion-note>{{ $t('components.alert-dates.anytime-note') }}</ion-note></ion-list><ion-icon class="arrow" name="arrow-forward" mode="ios" size="small" slot="end"></ion-icon></ion-item>
                        </ion-card>
                    </ion-card-content>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>
</template>

<script>
import CustomDate from '@/components/CustomDate.vue';
import axios from "axios";

export default {
    name: 'AlertDate',
    components: CustomDate,
    props: {
        to_type: Number,
        to_id: String,
        from_id: String,
    },
    data() {
        return {
            weekends: false,
            anytimeFill: "clear",
            anytime: false,
            customDates: [],
            currentModal: null,
            saveButton: false,
            savingScreen: false,
            saving: false,
            timeout: 10000,
        };
    },
    mounted() {
        this.$logger.debug('to_type', this.to_type, 'to_id', this.to_id);
        this.$on('dismissModal', () => {
            this.dismissModal();
        });

        this.$on('saveModal', (start, end) => {
            this.saveModal(start, end);
        });

        this.$AmplifyEventBus.$on('nextStep', this.clickNext);
    },
    beforeDestroy() {
        //the watcher gets destroyed too fast so we need to dismiss the loading here just in case
        if (this.savingScreen) {
            this.savingScreen.dismiss();
        }
    },
    methods: {
        toggleWeekends: function() {
            this.$logger.debug('toggle');
            this.weekends = !this.weekends;
            if (this.anytime) {
                this.anytime = false;
                this.anytimeFill = "outline";
            }
            this.showNext();
        },
        toggleCustom: function(id) {
            this.customDates[id].selected = !this.customDates[id].selected;
            this.customDates[id].fill = this.customDates[id].selected ? "solid" : "outline";
            if (this.anytime) {
                this.anytime = false;
                this.anytimeFill = "outline";
            }
            this.showNext();
        },
        //TODO: this needs to be replaced by a watcher
        showNext: function() {
            let custom = false;
            // eslint-disable-next-line no-unused-vars
            for (const cDate of this.customDates) {
                if (cDate.selected) {
                    custom = true;
                    break;
                }
            }
            if (this.anytime || this.weekends || custom ) {
                this.saveButton = true;
            } else {
                this.saveButton = false;
            }
        },
        formatDate: function(date) {
            this.$logger.debug(date);
            const bits = date.split('-');
            this.$logger.debug(bits);
            const dateObj = new Date(2020, bits[1], bits[0]);  // 2009-11-10
            const month = dateObj.toLocaleString('default', { month: 'short' });
            return {text: bits[0] + '/' + month.substr(0, 3), machine: (parseInt(bits[1]) + 1).toString().concat( bits[0] ) };
        },
        createModal: function() {
            return this.$ionic.modalController
            .create({
                component: CustomDate,
                componentProps: {
                    parent: this
                },
                cssClass: "custom-date-modal"
            })
            .then(m => {
                this.currentModal = m;
                m.present();
            })
        },
        dismissModal: function() {
            if (this.currentModal) {
                this.currentModal.dismiss().then(() => { this.currentModal = null; });
            }
        },
        saveModal: function(start, end) {
            this.$logger.debug('SAVE MODAL MAIN', start, end);
            const sDate = this.formatDate( start );
            const eDate = this.formatDate( end )
            this.customDates.push({id: this.customDates.length, selected: true, text: sDate.text + ' → ' + eDate.text, machine: [parseInt(sDate.machine),parseInt(eDate.machine)]});
            this.$logger.debug(this.customDates);
            if (this.currentModal) {
                this.currentModal.dismiss().then(() => { this.currentModal = null; });
            }
            this.showNext();
        },
        clickSave: function() {
            const dates = [];
            // eslint-disable-next-line no-unused-vars
            for (const customDate of this.customDates) {
                if (customDate.selected) {
                    dates.push(customDate.machine);
                }
            }
            if (this.weekends) {
                dates.push('WK');
            }
            this.$logger.debug('Dates', dates);

            this.commitAlert(dates);
        },
        clickAnytime: function() {
            const dates = [[101, 1231]];

            this.commitAlert(dates);
        },
        commitAlert: function(dates) {
            this.saving = true;

            this.$logger.debug(dates);
            this.$AmplifyEventBus.$emit('addAlertProgress', {step: 'end', value: 'ANY'});
            //store.setWizardDates(dates);

            this.$Amplify.Auth.currentAuthenticatedUser().then(user => {
                axios.post(process.env.VUE_APP_API_FEED_BASE + '/alerts',
                    {
                        from_city: this.from_id.toString(),
                        to_by: this.to_type.toString(),
                        to_id: this.to_id.toString(),
                        dates: dates
                    },
                    {
                        headers:
                            {
                                Authorization: `Bearer ${user.signInUserSession.getIdToken().getJwtToken()}`
                            }
                    }
                ).then(response => {
                    this.saving = false;
                    this.$logger.debug('DATA', response);
                    this.deals = response.data
                    this.$router.push('/');
                }).catch((err) => {
                    this.saving = false;
                    this.$logger.error(err);
                });
            }).catch((error) => {
                this.saving = false;
                this.$logger.debug(error);
                if (error.response && error.response.status === 401 || error == 'not authenticated') {
                    this.$logger.debug('unauthorized');
                    //this.$router.push('/welcome');
                }
                //this.$router.push('/welcome');
                this.$logger.debug('catch auth');
            });
        }
    },
    watch: {
        saving: function(val) {
            this.$logger.debug('trigger saving');
            if (val) {
                this.$ionic.loadingController.create({
                    message: this.$t('components.alert-dates.saving'),
                    duration: this.timeout,
                }).then(l => {
                    this.savingScreen = l;
                    l.present();
                    l.onDidDismiss().then(() => {
                        this.savingScreen = false;
                    });
                });
            } else {
                this.savingScreen.dismiss();
            }
        }
    }
}
</script>

<style scoped>
ion-button {
    margin: 1em auto;
}

.dates ion-item {
    margin: 0;
}

.date-selector {
    padding: 1em;
}

.add-custom {
    margin-top: 2em;
}

.selectable {
    --border-width: 1px;
}

.custom-date-first {
    margin-top: 2em;
}

.save {
    margin: .5em auto 0 auto;
}

.anytime {
    --inner-padding-start: 2.5em;
    --inner-padding-end: .5em;
    --background: #efc !important;
    --background-hover: #ac8;
}

.anytime ion-list {
    background: none;
    width: 100%;
}

.anytime ion-label {
    color: #666;
    font-size: 1.2em;
}

.anytime ion-note {
    color: #999;
}
</style>

<style>
    .custom-date-modal {
        padding: 3em;
        min-height: 17em;
        height: auto;
    }

    .custom-date-modal .modal-wrapper {
        min-height: 18em;
        height: auto;
        border-radius: 4px;
    }
</style>